import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Loader, MessageModal } from 'common/components';
import { RENEW_SESSION_TITLE, RENEW_SESSION_DESCRIPTION, msalInstance } from 'common/config';
import { ButtonLabel, MessageType } from 'common/enums';
import { RootState } from 'common/redux/core/root.reducer';
import { appStateActions } from 'common/redux/app-state';
import {
    getMessageModalDetails,
    getSessionRenewalVisibility,
    getShowLoader
} from 'common/redux/app-state/appState.selector';

const CommonModals = () => {
    const dispatch = useDispatch();

    const messageModalDetails = useSelector((state: RootState) => getMessageModalDetails(state));
    const isSessionRenewalVisible = useSelector((state: RootState) =>
        getSessionRenewalVisibility(state)
    );
    const isLoaderVisible = useSelector((state: RootState) => getShowLoader(state));

    const handleMessageModalClose = () => {
        dispatch(appStateActions.closeMessageModal());
    };

    const handleSessionRenewal = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
        dispatch(appStateActions.toggleSessionRenewal(false));
    };

    const handleLogout = () => {
        msalInstance.logoutRedirect();
    };

    return (
        <>
            {isLoaderVisible && <Loader isVisible={isLoaderVisible} />}
            {messageModalDetails && (
                <MessageModal
                    headerName={messageModalDetails.header}
                    message={messageModalDetails.message}
                    isVisible={messageModalDetails.isVisible}
                    type={messageModalDetails.type}
                    primaryButton={ButtonLabel.Ok}
                    onPrimaryAction={handleMessageModalClose}
                    onSecondaryAction={handleMessageModalClose}
                />
            )}
            {isSessionRenewalVisible && (
                <MessageModal
                    headerName={RENEW_SESSION_TITLE}
                    message={RENEW_SESSION_DESCRIPTION}
                    isVisible={isSessionRenewalVisible}
                    type={MessageType.Warning}
                    isCloseButtonHidden
                    isSecondaryButtonVisible
                    primaryButton={ButtonLabel.RenewSession}
                    secondaryButton={ButtonLabel.Logout}
                    onPrimaryAction={handleSessionRenewal}
                    onSecondaryAction={handleLogout}
                />
            )}
        </>
    );
};

export default CommonModals;
